import api from "@/lib/api";

export async function getSolicitacao({ cpf, id }) {
  const { data } = await api.get("/secretaria-digital/solicitacao", { params: { cpf, id } })
  return data
}